import { render, staticRenderFns } from "./reportDashboard.vue?vue&type=template&id=2be13c54&"
import script from "./reportDashboard.vue?vue&type=script&lang=js&"
export * from "./reportDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports